/* ── Engine viewer ────────────────────────────────────────────────
   Pointing at a marker reveals its label and spotlight and swaps the reading
   panel to that control. Leaving returns to the engine description, so the
   panel is never empty.

   THE THREE RULES ON TOUCH, and they are the whole contract:
     tap a marker              -> it opens
     tap a DIFFERENT marker    -> the first closes, the second opens
     tap anywhere else         -> everything closes

   That third rule did not exist. Nothing listened for a tap outside a marker,
   and the only other way out was blur, which was guarded by
   !classList.contains('is-open') and therefore could never clear an OPEN one.
   So an open marker could only be dismissed by tapping it again, and because
   iOS also leaves :hover stuck on whatever you last tapped, that second tap
   cleared .is-open while the stuck hover kept it lit, which needed a THIRD tap
   elsewhere. See ev-callouts-spot.css, where every :hover rule now sits behind
   @media (hover:hover) so .is-open is the single source of truth on touch.

   RETRACTING THE LEADER LINE
   The line is authored from the dot to the label, which means its tail sits on
   top of the control — covering the very thing it is pointing at (the word
   inside Delay's SYNC button, the word SHATTER in Diffusion). On load each line
   is re-anchored to the boundary of its highlight region, so it stops at the
   edge and the control underneath is never obscured.

   Everything degrades: with no JS the panel keeps showing the engine
   description and the lines simply stay full length. */
(function () {
  var panels = [].slice.call(document.querySelectorAll('.ev-panel'));
  if (!panels.length) return;
  var coarse = window.matchMedia && window.matchMedia('(hover:none)').matches;
  var num = function (el, a) { return parseFloat(el.getAttribute(a)) || 0; };
  var closers = [];   // every panel's "shut everything" function

  /* pull the line back to where it crosses the region boundary, plus a gap */
  function retract(co) {
    var frame = co.querySelector('.ev-co-frame');
    var line = co.querySelector('.ev-co-line');
    if (!frame || !line) return;
    var lx = num(line, 'x2'), ly = num(line, 'y2'), gap = 10, cx, cy, dx, dy, px, py;
    if (frame.tagName.toLowerCase() === 'circle') {
      cx = num(frame, 'cx'); cy = num(frame, 'cy');
      var r = num(frame, 'r') + gap;
      dx = lx - cx; dy = ly - cy;
      var len = Math.sqrt(dx * dx + dy * dy) || 1;
      px = cx + dx / len * r; py = cy + dy / len * r;
    } else {
      var x = num(frame, 'x'), y = num(frame, 'y');
      var w = num(frame, 'width'), h = num(frame, 'height');
      cx = x + w / 2; cy = y + h / 2;
      dx = lx - cx; dy = ly - cy;
      if (!dx && !dy) return;
      var sx = dx ? (w / 2 + gap) / Math.abs(dx) : Infinity;
      var sy = dy ? (h / 2 + gap) / Math.abs(dy) : Infinity;
      var s = Math.min(sx, sy);
      if (s >= 1) return;                 // the label already sits inside: leave it
      px = cx + dx * s; py = cy + dy * s;
    }
    line.setAttribute('x1', px.toFixed(1));
    line.setAttribute('y1', py.toFixed(1));
  }

  panels.forEach(function (panel) {
    var info = panel.querySelector('.ev-info');
    if (!info) return;
    var tEl = info.querySelector('.ev-info-t');
    var bEl = info.querySelector('.ev-info-b');
    var hint = info.querySelector('.ev-info-hint');
    var homeT = info.getAttribute('data-home-title') || '';
    var homeB = info.getAttribute('data-home-body') || '';
    var cos = [].slice.call(panel.querySelectorAll('.ev-co'));
    var pinned = null;

    function paint(title, body, isControl) {
      tEl.textContent = title;
      bEl.textContent = body;
      info.classList.toggle('is-control', !!isControl);
      if (hint) hint.style.visibility = isControl ? 'hidden' : '';
    }
    function home() { if (!pinned) paint(homeT, homeB, false); }

    function closeAll() {
      cos.forEach(function (o) { o.classList.remove('is-open'); });
      pinned = null;
      paint(homeT, homeB, false);
    }
    closers.push(closeAll);

    function open(co, t, b) {
      // close every OTHER marker first, so switching is one tap, not two
      cos.forEach(function (o) { if (o !== co) o.classList.remove('is-open'); });
      co.classList.add('is-open');
      pinned = co;
      paint(t, b, true);
    }

    cos.forEach(function (co) {
      retract(co);
      var t = co.getAttribute('data-title') || '';
      var b = co.getAttribute('data-body') || '';
      if (!coarse) {
        co.addEventListener('pointerenter', function () { paint(t, b, true); });
        co.addEventListener('pointerleave', home);
      }
      co.addEventListener('click', function () {
        if (co.classList.contains('is-open')) closeAll();   // tapping the open one shuts it
        else open(co, t, b);
      });
      co.addEventListener('focus', function () { pinned = co; paint(t, b, true); });
      co.addEventListener('blur', function () {
        if (pinned === co && !co.classList.contains('is-open')) pinned = null;
        home();
      });
    });

    panel.addEventListener('pointerleave', function () { if (!pinned) home(); });
  });

  /* THE MISSING RULE: a tap or click anywhere that is not a marker shuts them
     all. One listener for the whole page rather than one per panel, and it runs
     after the marker's own handler has bubbled, so opening a marker is never
     immediately undone by it. */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.ev-co')) return;
    closers.forEach(function (fn) { fn(); });
  });
})();
